import { TOKEN_KEY_PARAM } from '@/common/constants';

import useQueryParams from './useQueryParams';

const useToken = () => {
  const getQueryParams = useQueryParams();

  return getQueryParams.get(TOKEN_KEY_PARAM);
};

export default useToken;
